// total order
export default {
    // tab
    tab_all: "All orders",
    tab_notPaid: "Pending payment",
    tab_notConsumed: "To be used",
    tab_completed: "Completed",
    tab_closed: "closed",
    fl_keyword: "Enter search:",
    fp_keyword: "Mobile number/Order number",
    fl_startTime: "Creation time:",
    fp_startTime: "Pick a start time",
    fp_endTime: "Pick an end time",
    // 表格
    tl_id: "Order ID",
    tl_createTime: "Create time",
    tl_name: "User nickname",
    tl_mobile: "Mobile number",
    tl_amount: "Order Amount",
    tl_payModel: "Payment method",
    tl_channel: "Channel",
    tl_orderStatus: "Order Status",

    // 顶部
    heard_title: "Create order",
    heard_btn: "Return",
    nav_title: "User",
    fl_mobile: "Mobile phone number:",
    fp_mobile: "mobile number",
    form_number: "Number",
    queryBtn: "OK",
    btn_pay: "Payment",
    btn_addPrivate: "Add Private Farm",
    btn_edit: "Add item",
    btn_visitor: "Visitor Purchase",
    // 注册
    dt_nickName: "Username",
    dt_noUser: "No user found",
    content_title: "Register now as a new user",
    dp_regName: "nickname",
    em_regName: "Please enter a nickname",
    em_discountIpt: "Please enter a discount between 0-10",
    sm_reg: "Successful registration",
    em_reg: "Registration failed",
    // 查询
    em_queryUser: "Please enter your phone number",
    em_queryUser1: "Please enter a mobile phone number or number",
    em_queryUser2: "Please enter the mobile phone number in the correct format",
    sm_getUser: "The query succeeded",
    // 支付
    payTip1: "Successful payment",
    payTip2: "Payment failed",
    payTip3: "Payment result unknown",
    payStep1: "OK",
    payStep2: "Repay",
    em_authCode: "The payment code cannot be empty",
    em_payStatus:
        "The order has been paid successfully, please do not submit again",

    // 支付提示
    pay_amount: "Payment amount:",
    pay_unit: "Yuan",
    pay_way: "Payment method",

    // 支付方式选择
    dt_payLoding: "Paying",
    dl_needPay: "needPay:",
    dl_payModel: "Payment method:",
    dp_payModel: "payment method",
    op_wechatpay: "Wechat Pay",
    op_card: "Member Card",
    op_wallet: "Membership Card",
    op_cash: "Cash",
    op_pos: "swipe card",
    op_other: "Other",
    op_alipay: "Alipay",
    dl_authCode: "Payment code:",
    dp_authCode: " scan the payment code",
    btn_sendMail: "sendmail",
    dl_walletBalance: "walletBalance:",
    dl_paymentPassword: "password:",
    dl_earnedRates: "earnedRates:",
    dl_change: "change:",

    // 创建-优惠信息
    table_title2: "Promotion Information",
    fl_discountNum: "Discount amount:",
    fP_discountNum: "Please select",
    fl_discount: "Discount:",
    fp_discount: "Please select",
    countBox_desc: "Discount:",

    // 创建-支付信息
    pay_info_title: "Payment Information",
    pay_info_orderCount: "Total Order",
    pay_Info_disountNum: "Discount",
    pay_info_payStatus: "Pending payment",
    pay_Info_operator: "Operation",
    pay_info_btn: "Pay",

    // 商品订单详情—订单状态
    order_status: "Order Status:",
    btn_closeOrder: "Close order",
    btn_orderMemo: "Order Memo",

    // 订单详情状态 os:  order status
    os_paid: "Paid",
    os_nopay: "Not paid",
    os_refunded: "Refunded",
    os_canceled: "Canceled",
    os_noCancel: "To be written off",
    os_commented: "Commented",
    os_noComment: "To be commented",

    // 订单基本信息 ob：order base
    ob_title: "Basic Information",
    ob_orderNum: "Order Number",
    ob_userNum: "User Account",
    ob_payWay: "Payment Method",
    ob_channel: "Channel",
    ob_viewBtn: "View",

    // 场次信息 si : spec info
    si_title: "Show Information",
    si_specStatus: "Session Status",
    si_ticketChange: "Background change ticket",
    si_refundByOperator: "Manual Refund",
    si_completed: "Approved",
    si_paid: "To be written off",
    si_deny: "No",

    // 费用信息 ci : cost info
    ci_title: "Cost Information",
    ci_shopTotal: "Product Total",
    ci_couponNum: "Coupon",
    ci_orderTotal: "Total amount of order",
    ci_dueNum: "Payable Amount",

    // 操作信息  oi : operator info
    oi_title: "Operation Information",
    tl_operator: "Operator",
    tl_opeTime: "Operation time",
    tl_orderStatu: "Order Status",
    tl_payStatus: "Payment Status",
    tl_opeType: "Operation Type",
    tl_desc: "Remarks",

    // 编辑选手弹出框
    dt_editPlayer: "number&group&player",
    tl_kartName: "kartName",
    tl_number: "number",
    tl_group: "group",
    tl_player: "player",
    btn_enterSelf: "Self"
};
